import { BaseError } from '~/errors/BaseError'

export class ArgumentError extends BaseError {
  constructor(message: string) {
    super(message, 'ArgumentError', new Date().toISOString())
    this.name = this.error
  }
}
